<template>
    <b-alert show>
        {{$t('pages.selfservice.registration.emailValidation')}}
    </b-alert>
</template>

<script>
    /**
     * @description Stage ofr handling email validation
     *
     **/
    export default {
        name: 'Email-Validation'
    };
</script>


// WEBPACK FOOTER //
// src/components/selfservice/registration/EmailValidation.vue